/**
 * Canonical service type language.
 *
 * Stored / API: shared_load | exclusive_load
 * UI label:     Shared load | Exclusive load
 */

export const SERVICE_TYPE = Object.freeze({
  SHARED_LOAD: "shared_load",
  EXCLUSIVE_LOAD: "exclusive_load",
});

const SHARED_ALIASES = new Set([
  "shared_load",
  "shared-load",
  "shared load",
  "share_load",
  "share-load",
  "share load",
  "sl",
]);

const EXCLUSIVE_ALIASES = new Set([
  "exclusive_load",
  "exclusive-load",
  "exclusive load",
  "full_load",
  "dedicated",
  "dedicated_load",
  "dedicated-load",
  "dedicated load",
]);

/**
 * @param {unknown} value
 * @returns {"shared_load"|"exclusive_load"|null}
 */
export function normalizeServiceType(value) {
  if (value == null) return null;
  const raw = String(value).trim().toLowerCase().replace(/\s+/g, " ");
  if (!raw) return null;
  if (SHARED_ALIASES.has(raw)) return SERVICE_TYPE.SHARED_LOAD;
  if (EXCLUSIVE_ALIASES.has(raw)) return SERVICE_TYPE.EXCLUSIVE_LOAD;
  if (raw === "long_distance_share_load" || raw === "long_distance_shared_load") {
    return SERVICE_TYPE.SHARED_LOAD;
  }
  return null;
}

/**
 * @param {unknown} value
 * @returns {boolean}
 */
export function isSharedLoadType(value) {
  return normalizeServiceType(value) === SERVICE_TYPE.SHARED_LOAD;
}

/**
 * @param {unknown} value
 * @returns {"Shared load"|"Exclusive load"|string}
 */
export function formatServiceTypeLabel(value) {
  const normalized = normalizeServiceType(value);
  if (normalized === SERVICE_TYPE.SHARED_LOAD) return "Shared load";
  if (normalized === SERVICE_TYPE.EXCLUSIVE_LOAD) return "Exclusive load";
  if (value == null || String(value).trim() === "") return "Service type";
  return String(value);
}

/**
 * @param {unknown} moveType
 * @param {string|null|undefined} existingLoadType
 * @returns {string}
 */
export function serviceTypeToSopLoadType(moveType, existingLoadType) {
  const service = normalizeServiceType(moveType);
  if (service === SERVICE_TYPE.SHARED_LOAD) return "share_load";
  if (service === SERVICE_TYPE.EXCLUSIVE_LOAD) {
    if (
      existingLoadType &&
      normalizeServiceType(existingLoadType) !== SERVICE_TYPE.SHARED_LOAD
    ) {
      return existingLoadType;
    }
    return "full_load";
  }
  return existingLoadType || "full_load";
}
